import React, {useRef, useState, useEffect} from "react";
import {Swiper, SwiperSlide} from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import {Autoplay, Pagination, Navigation} from "swiper";
import './CarouselImageStyle.scss';
import axios from 'axios';
import fileManager from '../../Constants';
import axiosServise from "../../ApiService";

function CarouselImage() {
    const [sliderData, setSliderData] = useState([]);
    useEffect(() => {
        let MenuFromLocalStorage = localStorage.getItem('dataFromLocalStorage');
        if (MenuFromLocalStorage) {
            const Sliders = localStorage.getItem('Sliders');
            setSliderData(JSON.parse(Sliders));
        } else {
            axiosServise.get(`Sliders`).then(response => {
                const responseApi = response.data.content;
                setSliderData(responseApi)
                localStorage.setItem("Sliders", JSON.stringify(responseApi));
            })
        }
    }, []);


    return (
        <div className="carousel-container mySwiper" >
            <Swiper
                    spaceBetween={30}
                    centeredSlides={true}
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                    }}
                    pagination={{
                        clickable: true,
                    }}
                    navigation={true}
                    modules={[Autoplay, Pagination, Navigation]}
                    className="mySwiper" >
                {sliderData.map((item, index) => {
                    return (
                        <SwiperSlide key={index} title={item.title} onClick={item.sliderBase64}>
                            <div>
                                <img src={`data:image/jpeg;base64,${item.sliderBase64}`} className='carousel-img' alt=""/>
                                <div className="carousel-shadow" ></div>
                                <span className="carousel-title ">{item.title}</span>
                            </div>
                        </SwiperSlide>
                    )
                })}
                {/* <SwiperSlide>
            <img src={img3}  className='carousel-img' alt="" />
            <div className="carousel-shadow"></div>
            <span className="carousel-title">امام زاده جعفر (ع)</span>
            </SwiperSlide> */}
            </Swiper>


        </div>

    )
}

export default CarouselImage;